import BaseService from "./BaseService";
import {
  WhistleBlowerReportRequest,
  WhistleBlowerReportResponse,
  WhistleBlowerReportsResponse,
  PaginatedWhistleblowerReportsResponse
} from "./mappers/WhistleBlowerReportMapper";

class WhistleBlowerReportService extends BaseService {
  constructor() {
    super();
  }
  createReport(data) {
    return this.post(`whistleblowerreport/create/`, WhistleBlowerReportRequest(data))
      .then((response) => response.data)
      .then((data) => WhistleBlowerReportResponse(data));
  }

  createManualReport(data) {
    return this.post(`whistleblowerreport/investigator_create/`, WhistleBlowerReportRequest(data))
      .then((response) => response.data)
      .then((data) => WhistleBlowerReportResponse(data));
  }
  getWhistleBlowerReport(id) {
    return this.get(`whistleblowerreports/${id}/`)
      .then((response) => response.data)
      .then((data) => WhistleBlowerReportResponse(data));
  }
  getWhistleBlowerReports(page = 1, pageSize = 5, search = "", orderBy = null, desc = false) {
    let column = orderBy ? this.getOrderedColumnName(orderBy, desc) : null;
    let ordering = column ? `&ordering=${column}` : "";

    {
      return this.get(`whistleblowerreports/?page=${page}&page_size=${pageSize}&search=${search}${ordering}`)
        .then((response) => response.data)
        .then((data) => PaginatedWhistleblowerReportsResponse(data));
    }
  }
  updateWhistleblowerReport(data) {
    return this.patch(`whistleblowerreport/investigator_create/`, WhistleBlowerReportRequest(data))
      .then((response) => response.data)
      .then((data) => WhistleBlowerReportResponse(data));
  }
  deleteWhistleblowerReport(id) {
    return this.delete(`whistleblowerreports/${id}/`);
  }
}

export default new WhistleBlowerReportService();
